import type { ReactElement } from 'react';
import styled from 'styled-components';
import type { FilterKey } from './filters-config';
import { FILTERS } from './filters-config';

interface Props {
  value: FilterKey;
  /** Per-category device counts (computed client-side from the full set). */
  counts: Record<FilterKey, number>;
  onChange: (key: FilterKey) => void;
}

const Cards = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const Card = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  height: 60px;
  min-width: 84px;
  padding: 8px 14px;
  border-radius: 10px;
  text-align: left;
  background: rgba(17, 27, 51, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all var(--transition);

  &:hover {
    border-color: rgba(255, 255, 255, 0.16);
  }

  &.active {
    background: rgba(78, 95, 253, 0.16);
    border: 1px solid rgba(120, 130, 255, 0.4);
  }

  .count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 19px;
    font-weight: 700;
    color: var(--white);
  }

  .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
  }

  .label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--white35);
  }
`;

export const StatCards = ({ value, counts, onChange }: Props): ReactElement => (
  <Cards>
    {FILTERS.map((filter) => (
      <Card
        key={filter.key}
        type='button'
        className={filter.key === value ? 'active' : ''}
        onClick={(): void => {
          onChange(filter.key);
        }}
      >
        <div className='count'>
          {filter.dot !== undefined && <span className='dot' style={{ background: filter.dot }} />}
          {counts[filter.key]}
        </div>
        <div className='label'>{filter.cardLabel}</div>
      </Card>
    ))}
  </Cards>
);
